/**
 * @typedef {'pipes'} VIEW_TYPE_PIPES
 * @typedef {'parts'} VIEW_TYPE_PARTS
 */
export const VIEW_TYPE_PIPES = 'pipes';
export const VIEW_TYPE_PARTS = 'parts';
